import React from 'react';
import { Field } from "redux-form";

import Moment from 'moment';
import momentLocalizer from 'react-widgets-moment';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';

import 'react-widgets/dist/css/react-widgets.css';

import {EVENT_DATE } from "../../constants/Game";
import moment from "moment";

Moment.locale('en');
momentLocalizer();

/*
  State is:  checkbox checked -- yes/no = same as date is null/non-null.
             Date:  only visible as non-null.

     When checkbox is checked -- do not send an event; instead open date picker
     When we have a date -- send event of date (or null if none chosen)
 */
export const EventHuntChoice = (props) => {

    // state determined by dateValue:  if it's null, hide the date picker and set toggle of unselected.
    // if it's yes, show date field & picker, with date.
    // assuming we manage state for this thing in the containing class.

    const { onDateChange, onEventHuntChecked, dateValue/*, randomClueOrder, onRandomClueOrderChecked*/ } = props;

    const underText = !!dateValue ? "Yes.  No clues until this start time.  No skipping clues, etc."
                                  : "No.  Players can start the hunt freely at any time and skip clues, etc.";

   // const underTextRandomClues = randomClueOrder ? "Yes. Randomize the clue order for each player. "
   //    : "No. The clue order will be as you author it, the same for each player.";

   // const showRandomClueChoice = !!dateValue;

    return (
        <div className="form-group row">
            <label htmlFor="isEvent" className="col-sm-2 col-form-label">Event Hunt? </label>
            <div className="col-sm-6">
                <div>
                    <Field
                        name="isEvent"
                        component="input"
                        type="checkbox"
                        onChange={onEventHuntChecked}
                        checked= {!!dateValue}
                    />
                    <label className="left-margin" htmlFor="isEvent">

                    </label>
                </div>
                {!!dateValue &&
                    <div className="top-margin-half">
                        <DateTimePicker
                            culture={'en'}
                            name={EVENT_DATE}
                            dropUp={true}
                            defaultValue={dateValue.toDate()}
                            onChange={onDateChange}
                        />
                    </div>
                }
                <p className="secondary-text top-margin-half">{underText}</p>
            </div>
           {/*{showRandomClueChoice &&*/}
           {/*<div className="col-sm-6">*/}
           {/*   <Field*/}
           {/*      name="randomizeClues"*/}
           {/*      component="input"*/}
           {/*      type="checkbox"*/}
           {/*      onChange={onRandomClueOrderChecked}*/}
           {/*      checked= {randomClueOrder}*/}
           {/*   />*/}
           {/*   <label className="left-margin" htmlFor="randomizeClues">*/}
           {/*      Randomize clue order?*/}
           {/*   </label>*/}
           {/*   <p className="secondary-text bottom-margin">{underTextRandomClues}</p>*/}
           {/*</div> }*/}
        </div>
     )
};

export function saturdayAtNoon() {
   return moment().day(6).hour(12).minute(0).second(0).milliseconds(0).toDate();
}



// WEBPACK FOOTER //
// ./src/components/huntcomponents/EventHuntChoice.js